import { ColumnConfig } from '@/shared/types/table';

export const reorderColumns = <T>(
  columns: ColumnConfig<T>[],
  fromIndex: number,
  toIndex: number,
): ColumnConfig<T>[] => {
  const result = [...columns];
  const [removed] = result.splice(fromIndex, 1);
  result.splice(toIndex, 0, removed);
  return result;
};

export const toggleColumnVisibility = <T>(
  columns: ColumnConfig<T>[],
  columnId: string,
): ColumnConfig<T>[] => {
  return columns.map((col) => (col.id === columnId ? { ...col, visible: !col.visible } : col));
};

export const setColumnVisibility = <T>(
  columns: ColumnConfig<T>[],
  columnId: string,
  visible: boolean,
): ColumnConfig<T>[] => {
  return columns.map((col) => (col.id === columnId ? { ...col, visible } : col));
};

export const toggleColumnLock = <T>(
  columns: ColumnConfig<T>[],
  columnId: string,
): ColumnConfig<T>[] => {
  return columns.map((col) => (col.id === columnId ? { ...col, locked: !col.locked } : col));
};

export const resizeColumn = <T>(
  columns: ColumnConfig<T>[],
  columnId: string,
  width: number,
): ColumnConfig<T>[] => {
  return columns.map((col) => (col.id === columnId ? { ...col, width } : col));
};

export const resetColumns = <T>(defaultColumns: ColumnConfig<T>[]): ColumnConfig<T>[] => {
  return defaultColumns.map((col) => ({
    ...col,
    visible: true,
    locked: false,
    width: col.width,
  }));
};

export const getVisibleColumns = <T>(columns: ColumnConfig<T>[]): ColumnConfig<T>[] => {
  return columns.filter((col) => col.visible !== false);
};

export const getLockedColumns = <T>(columns: ColumnConfig<T>[]): ColumnConfig<T>[] => {
  return columns.filter((col) => col.locked === true);
};
